export default "__VITE_ASSET__d0b3f934__"